export const MATCHA_POLLING_IDLE_TIMEOUT_MS = 3 * 60 * 1000;
